<script setup lang="ts">
import type {HTMLAttributes} from 'vue'
import {tw} from "../../../utils/tailwind";
import {useCarousel} from "./useCarousel.ts";

const {allItemsVisible} = useCarousel()

interface Props {
  class?: HTMLAttributes['class']
  asChild?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  asChild: true,
})
</script>

<template>
  <button
      v-cloak
      v-show="!allItemsVisible"
      :as-child="asChild"
      :class="tw(
          'flex items-center justify-center gap-2 p-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
          'bg-transparent text-inherit',
           props.class,
      )"
  >
    <slot/>
  </button>
</template>
